export default "__VITE_PUBLIC_ASSET__90fcc3f3__"